import React from 'react';
import LCSubPageLayout from './LCSubPageLayout';
import LCEvents from './LCEvents';

const LCEventsPage: React.FC = () => (
  <LCSubPageLayout title="Events">
    {(detail) => (
      <LCEvents
        id={detail.id}
        lcAccess={detail.local_chapter_access}
        canEditEvents={detail.can_edit_events || false}
      />
    )}
  </LCSubPageLayout>
);

export default LCEventsPage;
